import { render, staticRenderFns } from "./RecycleBin.vue?vue&type=template&id=79e89822&scoped=true"
import script from "./RecycleBin.vue?vue&type=script&lang=js"
export * from "./RecycleBin.vue?vue&type=script&lang=js"
import style0 from "./RecycleBin.vue?vue&type=style&index=0&id=79e89822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e89822",
  null
  
)

export default component.exports